import React, { Component, useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import sectiondata from '../../data/sections.json';

import { Spin } from "antd";
import PropertyCallingButton from "../../utils/PropertyCardCall";
import PropertyWhatsAppButton from "../../utils/PropertyCardWhatsApp";
import FormatePrice from "../../utils/FormatePrice";
import GetInTouch from "../../utils/getInTouch";
import { Button, Modal } from "antd";
import PropertyDetailsList from "../../JsonData/property-details.json"
import { slugify } from "../../utils/slugify";
import DeveloperDetails from "./developerDetails";

const SimilarDeveloper = ({ DeveloperName }) => {

    console.log(DeveloperName, "typeeeeeee");
    
    const [propertices, setPropertices] = useState([]);
    const [loading, setLoading] = useState(false);

    const [open, setOpen] = useState(false);
    const showModal = () => setOpen(true);
    const handleCancel = () => setOpen(false);

    let propertydata = PropertyDetailsList.PropertyDetailsList

    const getpropertylist = async () => {
        setLoading(true);
        try {
            const filterProperties = propertydata.filter((item) =>
                 item.DeveloperName?.toLowerCase() === DeveloperName.toLowerCase()
            )

            setPropertices(filterProperties);
        } catch (error) {
            console.error("Error fetching properties:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (DeveloperName) {
            getpropertylist();
        }
    }, [DeveloperName]);



    let publicUrl = process.env.PUBLIC_URL + '/'
    let imagealt = 'image'
    let data = sectiondata.property_rent


    return <div className="properties-area pd-top-82">
        <div className="container">
            {loading ? (
                // <div className="text-center">Loading properties...</div>
                <div className="text-center py-5">
                    <Spin className="custom-orange-spin" size="large" tip="Loading properties..." />
                </div>
            ) : (
                <>
                    <div className="row">
                        {propertices?.length > 0 ? (
                            propertices?.map((item, index) => {
                                const images = item.images || []

                                return (
                                    <div key={index} className="col-xl-4 col-sm-6">
                                        <div className="single-feature">
                                            {/* <div className="thumb">
                                                {images.length > 1 ? (
                                                    <Slider {...carouselSettings}>
                                                        {images?.map((img, index) => (
                                                            <div key={index}>
                                                                <img
                                                                    src={img?.src}
                                                                    alt={`Property ${index}`}
                                                                    className="img-fluid property-image"
                                                                    style={{ height: '250px', objectFit: 'cover', width: '100%' }}
                                                                />
                                                            </div>
                                                        ))}
                                                    </Slider>
                                                ) : (
                                                    <img
                                                        src={images[0]?.src}
                                                        alt="No image available"
                                                        className="img-fluid"
                                                        style={{ height: '250px', objectFit: 'cover', width: '100%' }}
                                                    />
                                                )}
                                            </div> */}

                                            <div className="thumb position-relative">
                                                <Button
                                                    className="position-absolute"
                                                    style={{
                                                        top: '10px',
                                                        right: '10px',
                                                        zIndex: 2,
                                                        padding: '6px 12px',
                                                        fontSize: '14px',
                                                        borderRadius: '5px',
                                                        width: "150px",
                                                        color: "#FDA94F"
                                                    }}
                                                    onClick={showModal}
                                                >
                                                    Enquire Now
                                                </Button>
                                                <img
                                                    src={images[0]?.src}
                                                    alt="Property"
                                                    className="img-fluid property-image"
                                                    style={{
                                                        height: '250px',
                                                        width: '100%',
                                                        objectFit: 'cover',
                                                        imageRendering: 'auto',
                                                        display: 'block',
                                                        backfaceVisibility: 'hidden',
                                                        transform: 'translateZ(0)',
                                                        WebkitBackfaceVisibility: 'hidden'
                                                    }}
                                                />
                                            </div>


                                            <div className="details">
                                                {/* {data.items.map((item, i) =>
                                                <a href="#" className="feature-logo">
                                                    <img src={publicUrl + item.icon} alt={imagealt} />
                                                </a>
                                            )} */}
                                                {/* <p className="author" style={{ gap: "15px" }}><i className="fa fa-user" />{item.name || 'Unknown'}</p> */}
                                                <h6 className="price">
                                                    {FormatePrice(item.price)} AED
                                                    {/* {item.olderprice && <del> {item.olderprice}</del>} */}
                                                </h6>
                                                <h6 className="title readeal-top"><Link >{item.PropertyName}</Link></h6>
                                                <h6 className="title readeal-top" style={{ fontSize: "12px" }}> <i class="fa fa-home" style={{ color: "orange", fontSize: "15px" }}></i>  {item.building_type}</h6>
                                                <p className="location"><i className="fa fa-map-marker" style={{ marginRight: '5px', color: 'red', color: "orange " }} />
                                                    {item.locality}</p>

                                                <ul className="info-list">
                                                    <li key={index}><i className="fa fa-bed" /> {item.number_bedroom}</li>
                                                    {/* <li><i className="fa fa-bath" /> {item.number_bathroom}</li> */}
                                                    <li><img src={"/assets/img/icons/7.png"} alt={imagealt} /> {item.builtup_area} sq ft</li>
                                                </ul>
                                                <ul className="contact-list">
                                                    <li className="readeal-top"><Link className="btn btn-yellow"
                                                        //  to={item.url}
                                                        to={`/property-details/${slugify(item.PropertyName)}`}
                                                    >View Details</Link></li>

                                                    <li>
                                                        <PropertyCallingButton />
                                                    </li>

                                                    <li>
                                                        <PropertyWhatsAppButton />
                                                    </li>

                                                </ul>
                                            </div>
                                        </div>
                                        <Modal
                                            title=""
                                            open={open}
                                            onCancel={handleCancel}
                                            footer={null}
                                            maskStyle={{ backgroundColor: 'transparent' }}  //  background black nahi hoga
                                            maskClosable={false}  //  background pe click karne se close bhi nahi hoga
                                        >
                                            <GetInTouch onClose={handleCancel} />
                                        </Modal>
                                    </div>
                                )
                            })
                        ) : (
                            <div className="col-12 text-center">
                                <p>No properties found matching your criteria.</p>
                            </div>
                        )}
                    </div>
                  
                </>
            )}
        </div>
    </div>




}
export default SimilarDeveloper;